/**
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { EspCommand, EspCommandPacket, EspPacketDirection } from "./command";

export class EspCommandReadReg extends EspCommandPacket {
  private readRegData = new ArrayBuffer(4);

  constructor(address: number) {
    super();

    this.command = EspCommand.READ_REG;
    this.direction = EspPacketDirection.REQUEST;
    new DataView(this.readRegData).setUint32(0, address, true);
    this.data = new Uint8Array(this.readRegData);
  }
}
